

import { all, call, put, takeLatest } from "redux-saga/effects";
import { Types } from "../../types";
import { outGoingErrorAction, outGoingSuccessAction } from "../../actions/OutgoingCallAction";
import { ouGoing } from "../apiRequests/outGoing";




function* outGoingHandler(action: any) {
    try {
        const response: { data: boolean } = yield call(ouGoing, action.payload.params)
        yield put(
            outGoingSuccessAction({
                params: response.data
            })
        )

    } catch (error: any) {
        yield put(
            outGoingErrorAction({
                error: error
            })
        )

    }
}




function* outGoingSaga() {
    yield all([takeLatest(Types.OUGOING_CALL_REQUEST, outGoingHandler)]);


}

export default outGoingSaga